var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnePiece(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3B55E6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98,66.97H22c-0.55,0-1-0.45-1-1v-20c0-0.23,0.08-0.45,0.22-0.62C26.24,39.08,29,31.2,29,23.17V5.97 c0-0.55,0.45-1,1-1h17.36c0.39,0,0.74,0.22,0.9,0.57c2.16,4.58,6.66,7.43,11.74,7.43s9.57-2.85,11.74-7.43 c0.17-0.35,0.52-0.57,0.9-0.57H90c0.55,0,1,0.45,1,1v17.19c0,8.03,2.76,15.91,7.78,22.18c0.14,0.18,0.22,0.4,0.22,0.62v20 C99,66.53,98.56,66.97,98,66.97z M23,64.97h74V46.32c-5.16-6.58-8-14.79-8-23.15V6.97H73.26c-2.59,4.95-7.62,8-13.26,8 s-10.67-3.05-13.26-8H31v16.19c0,8.37-2.84,16.58-8,23.15V64.97z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.06,73.03H21.94c-0.55,0-1-0.45-1-1v-6c0-0.55,0.45-1,1-1h76.13c0.55,0,1,0.45,1,1v6 C99.06,72.58,98.62,73.03,98.06,73.03z M22.94,71.03h74.13v-4H22.94V71.03z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.06,93.93c-0.01-0.1-0.04-0.2-0.08-0.29l-6-22c-0.16-0.37-0.52-0.61-0.92-0.61H21.94 c-0.4,0-0.76,0.24-0.92,0.61l-6,22c-0.04,0.09-0.07,0.19-0.08,0.29l-6,20c-0.03,0.28,0.06,0.56,0.25,0.77 c0.19,0.21,0.46,0.33,0.74,0.33h46h20h34.13c0.28,0,0.55-0.12,0.74-0.33c0.19-0.21,0.28-0.49,0.25-0.77L105.06,93.93z  M76.78,113.03H55.09H11.04l5.87-18.75l5.68-21.25h74.81l5.68,21.25l5.87,18.75H76.78z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnePiece);
export default __webpack_public_path__ + "static/media/onePiece.5926a2a74ba4f6d221e47e39abea702f.svg";
export { ForwardRef as ReactComponent };